import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage } from "gatsby-plugin-image";

const HeroImage = ({ image }) => {
  return <GatsbyImage image={image.gatsbyImageData} alt={image.title} />;
};

HeroImage.propTypes = {
  image: PropTypes.object.isRequired
};

export default HeroImage;
